import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DayComponent } from './day/day.component';
import { SettingsComponent } from './settings/settings.component';
import { DevComponent } from './dev/dev.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LandingComponent } from './landing/landing.component';
import { userLoggedInGuard } from '../services/auth/user-logged-in.guard';
import { MinWriterComponent } from './min-writer/min-writer.component';
import { SupaStatisticsComponent } from './statistics/supa-statistics.component';

// const authGuard = canActivate(() => redirectUnauthorizedTo('login'))

const userLoggedIn = userLoggedInGuard('login');
const userLoggedOut = userLoggedInGuard('today', false);


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingComponent,
    canActivate: [userLoggedOut]
  },
  {
    path: 'landing',
    component: LandingComponent
  },
  {
    path: 'register/:key',
    component: RegisterComponent,
    canActivate: [userLoggedOut]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [userLoggedOut]
  },
  {
    path: 'understand',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [userLoggedIn]
  },
  {
    path: 'topics',
    loadChildren: () => import('./topic/topic.module').then(m => m.TopicModule),
    canActivate: [userLoggedIn]
  },
  {
    path: 'today',
    component: DayComponent,
    canActivate: [userLoggedIn],
  },
  {
    path: 'day/:date',
    component: DayComponent,
    canActivate: [userLoggedIn]
  },
  {
    path: 'min-writer',
    component: MinWriterComponent,
    canActivate: [userLoggedIn],
  },
  {
    path: 'plan',
    loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarModule),
    canActivate: [userLoggedIn]
  },
  {
    path: 'stats',
    component: SupaStatisticsComponent,
    canActivate: [userLoggedIn]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [userLoggedIn]
  },
  {
    path: 'dev',
    component: DevComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
